import React, { PropsWithChildren } from 'react';

import { Container, Text } from './style';

type Props = {
  variant?: 'danger' | 'success' | 'info' | string;
  className?: string;
};

const Alert: React.FC<PropsWithChildren<Props>> = ({ children, variant, className }) => {
  return (
    <Container
      className={className}
      variant={variant}
    >
      <Text>{children}</Text>
    </Container>
  );
};

export default Alert;
